(() => {
  // Judge.me renders this text-expansion control as an anchor without a URL.
  // Keep the original node and its vendor click handlers; expose its true role.
  const selector = 'a.jdgm-carousel__rev-sum-read-more:not([href])';

  function enhance(control) {
    control.setAttribute('role', 'button');
    control.setAttribute('tabindex', '0');
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) enhance(node);
    node.querySelectorAll(selector).forEach(enhance);
  }

  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('keydown', event => {
    if (event.defaultPrevented || event.repeat || !event.target.matches?.(selector)) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.target.click();
  });
})();
